exports = module.exports = require("../../../NodeModules/Ljbc/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ninput[type=number][data-v-59783214]::-webkit-inner-spin-button,\ninput[type=number][data-v-59783214]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n", ""]);

// exports
